module.exports = __webpack_public_path__ + "assets/img/tabStartup.db19efd3.png";